import React from 'react';
import Lottie from 'react-lottie';
import { useUserInfo } from '@repository/auth/useUserInfo';
import certificationFail from '@graphic/certificationFail.json';
import { JOBDA_SUPPORT_EMAIL } from '@domain/constant/contact';

import classnames from 'classnames/bind';
import styles from './certificationFail.module.scss';
const cx = classnames.bind(styles);

const options = {
  loop: true,
  autoplay: true,
  animationData: certificationFail,
};

const CertificationFail = () => {
  const { data: userInfo } = useUserInfo();
  const userName = userInfo?.name ?? '회원';

  return (
    <div className={cx('certificationArea')}>
      <div className={cx('logo')}>
        <span className={cx('hidden')}>JOBDA</span>
      </div>

      <div className={cx('infoArea')}>
        <div className={cx('lottieWrap')}>
          <Lottie options={options} />
        </div>

        <div className={cx('text')}>휴대폰 인증 실패</div>

        <em className={cx('title')}>
          인증 정보가
          <br />
          {userName}님의 정보와 달라요.
        </em>

        <p className={cx('desc')}>
          잡다의 회원정보와 응시자 정보가 다르면
          <br />
          역검 결과를 저장할 수 없어요.
        </p>

        <a className={cx('btn')} href={`mailto:${JOBDA_SUPPORT_EMAIL}`}>
          잡다에 문의하기
        </a>

        <p className={cx('notice')}>
          진행 중 문제가 발생할 경우 <span className={cx('link')}>{JOBDA_SUPPORT_EMAIL}</span>로 문의해주세요.
        </p>
      </div>
    </div>
  );
};

export default CertificationFail;
